export const LOGIN_ROUTE = "/admin";
export const DASHBOARD_ROUTE = "/admin/dashboard";
export const SETTING_ROUTE = "/admin/setting";
export const SERVER_INFO_ROUTE = "/admin/server-info";
export const MAIN_CATEGORY_ROUTE = "/admin/main-category";
export const SUB_CATEGORY_ROUTE = "/admin/sub-category";
export const CATEGORY_ROUTE = "/admin/category";
export const BRAND_ROUTE = "/admin/brand";
export const MODEL_ROUTE = "/admin/model";
export const SERIES_ROUTE = "/admin/series";
export const COUPON_ROUTE = "/admin/coupon";
export const ATTRIBUTE_ROUTE = "/admin/attribute";
export const ATTRIBUTE_QUESTION_ROUTE = "/admin/attribute-question";
export const PRODUCT_ROUTE = "/admin/product";
export const ORDER_ROUTE = "/admin/order";
export const COMMISSION_ROUTE = "/admin/commission";
export const USER_ROUTE = "/admin/user";
export const PARTNER_ROUTE = "/admin/partner";
export const PROFILE_ROUTE = "/admin/profile";
export const LEDGER_ROUTE = "/admin/ledger";
export const COLLECTION_ROUTE = "/admin/collection-history";
export const OTP_ROUTE = "/admin/otps";
export const FORGOT_ROUTE = "/admin/forgot-password";


export const ADMIN_CATEGORY_ROUTE = "/admin/import-category";
export const VENDOR_CATEGORY_ROUTE = "/admin/import-vendor-category";
export const MENU_PRICING_ROUTE = "/admin/menu-pricing";

export const CORPORATE_CODE_ROUTE = "/admin/corporate-code";


export function  PRODUCT_BY_EXCEL(id){
   return `/admin/excel-products/${id}`;
}








export const VENDOR_ROUTE ="/admin/vendor"
export const VENDOR_STAFF_ROUTE ="/admin/vendor-manager"
export const SUPER_ADMIN_ROUTE ="/admin/head-admin"
export const ADMIN_ROUTE ="/admin/tower-admin"
// address
export const COUNTRY_ROUTE ="/admin/country"
export const STATE_ROUTE ="/admin/state"
export const CITY_ROUTE ="/admin/city"

export const PAYMENT_GATEWAY_ROUTE ="/admin/payment-gateway"


export function INVOICE_ROUTE(id) {
  return `/admin/invoice/${id}`;
}
export function INVOICE_PARTNER_ROUTE(id) {
  return `/admin/invoice-partner/${id}`;
}


export const MEALS_ROUTES = "/admin/meals";
export const REVENUE_ROUTES = "/admin/revenues";
export const TOP_SELLING_ROUTES = "/admin/top-selling-products";
export const EMP_ROUTES = "/admin/emp-feed";
export const EMP_USAGE_ROUTES = "/admin/no-of-app-users";